import CardValidator from 'card-validator';

import { getCardCodeSizes } from '@/core/payment-card/utilities/cvv';

export default class PaymentCardValidator {
    static validateCvv(value, cardNumber) {
        return CardValidator
            .cvv(value, getCardCodeSizes(cardNumber))
            .isValid;
    }

    static validateNumber(value) {
        const numberValidation = CardValidator.number(value);

        return numberValidation.isValid;
    }

    static validateExpiration(value) {
        const expirationValidation = CardValidator.expirationDate(value);

        return expirationValidation.isValid;
    }

    static validateUnsupportedCardTypes(value: string, unsupportedCardTypes: Array<string>) {
        if (!unsupportedCardTypes?.length) {
            return true;
        }

        const cardType = CardValidator.number(value);

        if (!cardType.card?.type) {
            return true;
        }

        return !unsupportedCardTypes.includes(cardType.card.type);
    }

    static validateCardHolder(value: string) {
        try {
            const notOnlySpacesAndDigits = /^(?![\s\d]*$).+/;

            return value?.toString().trim().length > 1 && notOnlySpacesAndDigits.test(value);
        } catch (e) {
            return false;
        }
    }
}
